import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchLeagueView } from '../../api/api';
import LeagueView from './LeagueView';
import Spinner from '../Spinner/Spinner';
import styles from '../TourCurForm/TourCurForm.module.css';

const competitionSystemMapping = {
    ROUND_ROBIN: 'Każdy z każdym',
    KNOCKOUT: 'Pucharowy',
    BRAZILIAN: 'Brazylijski do dwóch przegranych',
    BRAZILIAN_FAST: 'Brazylijski szybki',
    COMBINED: 'Faza grupowa + faza finałowa',
    GROUP_LEAGUE: 'Liga grupowa'
};

const LeagueViewPage = () => {
    const { tournamentId } = useParams();
    const navigate = useNavigate();
    const [tournament, setTournament] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const load = async () => {
            const result = await fetchLeagueView(tournamentId, null);
            if (result.success && result.data?.tournament) {
                setTournament(result.data.tournament);
            } else {
                setError('Nie znaleziono ligi.');
            }
        };
        load();
    }, [tournamentId]);

    if (error) return <div style={{ padding: 20, textAlign: 'center' }}>{error}</div>;
    if (!tournament) return <Spinner size="large" />;

    const isArchived = tournament.status === 'COMPLETED';
    const handleReturn = () => navigate('/tournaments');

    return (
        <div className={styles.container}>
            <div className={styles.backRow}>
                <button className={styles.returnCurButton} onClick={handleReturn}>
                    ← Powrót
                </button>
            </div>
            <div className={styles.header}>
                <div className={styles.title}>{tournament.title}</div>
            </div>
            <div className={styles.metaLine}>
                <a href="/competition-descriptions" target="_blank" rel="noreferrer"
                   className={styles.metaSystem}>
                    {competitionSystemMapping[tournament.competitionSystem]}
                </a>
                {!isArchived &&
                    <>
                        <span className={styles.metaDot}></span>
                        <a href="/score-rules" target="_blank" rel="noreferrer"
                           className={styles.metaLink}>Zasady gry</a>
                    </>
                }
            </div>
            <LeagueView
                tournament={tournament}
                isArchived={isArchived}
                onReturn={handleReturn}
            />
        </div>
    );
};

export default LeagueViewPage;
